'use client';

import { usePathname } from 'next/navigation';
import { Navbar } from './nav';
import { QuantNav } from './QuantNav';
import { NewNavWrapper } from './NewNavWrapper';

export function NavWrapper() {
  const pathname = usePathname();
  const showNavbar =
    !pathname.split('/').includes('download') &&
    !pathname.split('/').includes('refer') &&
    !pathname.split('/').includes('app-download')
  const isQuantNav = pathname
    .split('/')
    .some((path) => ['ai-earn', 'ai-earn-detail'].includes(path));

  const isNewNav = pathname
    .split('/')
    .some((path) => ['home', 'app', 'marketplace', 'document', 'trader'].includes(path));

  return <>{showNavbar ? isQuantNav ? <QuantNav /> : isNewNav ? <NewNavWrapper /> : <NewNavWrapper /> : null}</>;
}
